import { render, staticRenderFns } from "./UserCommunity.vue?vue&type=template&id=51986a51&scoped=true&"
import script from "./UserCommunity.vue?vue&type=script&lang=js&"
export * from "./UserCommunity.vue?vue&type=script&lang=js&"
import style0 from "./UserCommunity.vue?vue&type=style&index=0&id=51986a51&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51986a51",
  null
  
)

export default component.exports